import moment from 'moment'
import { Trans, useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { EventHookInterface } from '../../types'
import { colors } from '../../utils'
import { SectionField } from '../Inputs/SectionField'
import { RepeatEvent } from './RepeatEvent'

const Date = styled.span`
  color: ${colors.purple};
`
const Subheader = styled.div`
  .pb-16 {
    padding-bottom: 16px;
  }
`
export const RepeatEventSection: React.FC<{
  eventHook: EventHookInterface
}> = ({ eventHook }) => {
  const { t } = useTranslation('common')

  const { isEditable, value: event } = eventHook
  const { is_recurring, selectedDate, event_paid_type } = event

  const date = moment(selectedDate).local().format('MMMM DD, YYYY')

  return is_recurring && event_paid_type !== 1 ? (
    <SectionField
      header={t(`Repeat event`, `Repeat event`)}
      subheader={
        isEditable && (
          <Subheader>
            <div className="pb-16">
              {t(
                `Select the dates and frequency of your recurring event.`,
                `Select the dates and frequency of your recurring event.`,
              )}
            </div>
            {selectedDate && (
              <Trans i18nKey="RepeatEvent-20220401183452657552546">
                Your first series event is on
                <br />
                <Date>{{ date }}</Date>.
              </Trans>
            )}
          </Subheader>
        )
      }>
      <RepeatEvent eventHook={eventHook} />
    </SectionField>
  ) : null
}
